export function getNextPackageId(currentId) {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let carry = true;
  let nextId = "";

  for (let i = currentId.length - 1; i >= 0; i--) {
    const index = letters.indexOf(currentId[i]);
    if (index === -1) {
      throw new Error("Invalid package ID");
    }

    if (carry) {
      if (index === letters.length - 1) {
        nextId = "A" + nextId;
      } else {
        nextId = letters[index + 1] + nextId;
        carry = false;
      }
    } else {
      nextId = currentId[i] + nextId;
    }
  }

  if (carry) {
    nextId = "A" + nextId;
  }

  return nextId;
}
const getStatement = (restriction, brandLink) => {
  switch (restriction) {
    case "geo_blocks_visitors":
      return `${brandLink} may block or limit access to its website from certain countries using geolocation restrictions.`
    case "geo_price_optimization":
      return `${brandLink} may use geolocation to adjust pricing, product availability, or promotions, which could result in higher prices based on your location.`
    case "restrict_forwarding_addresses":
      return `${brandLink} may restrict shipping to package forwarding or freight-forwarder addresses and may cancel orders shipped to reshipping warehouses.`
    case "restrict_international_cards":
      return `${brandLink} may restrict certain international credit/debit cards or reject non-local billing addresses during checkout.`
    case "restrict_international_returns":
      return `${brandLink} may restrict international returns or refuse return requests for items shipped outside the original purchase region.`
    case "restrict_international_warranties_coverage":
      return `${brandLink} may restrict warranty coverage based on the country of purchase, meaning warranty claims may not apply internationally.`
  }
}

const byPassStatements = {
  "B1": "Get POSTPAL Warranty to protect your purchase",
  "B2": "Let POSTPAL do the purchase and manage issues from the qualified purchase region.",
  "B3": "Use an alternate forwarding address provided by the warehouse listed below.",
  "B4": "If your address is blocked, generate an alternate address.",
  "B5": "Ask a friend or family member in the store’s region to buy the item and ship it to your POSTPAL warehouse.",
  "B6": "Ship the item back to the POSTPAL warehouse so it can be returned to the retailer locally.",
  "B7": "POSTPAL can assist with product returns/exchanges.",
  "B8": "Activate POSTPAL VPN Shopping to access local pricing and promotions.",
  "B9": "POSTPAL can assist with contacting the manufacturer from the qualified purchase country."
}

const getByPassStatementsByHeading = (restriction, brandLink) => {
  console.log(restriction, "restrictionssss")
  switch (restriction) {
    case "geo_blocks_visitors":
      return [byPassStatements["B2"], byPassStatements["B5"]]
    case "geo_price_optimization":
      return [byPassStatements["B8"], byPassStatements["B2"]]
    case "restrict_forwarding_addresses":
      return [byPassStatements["B3"], byPassStatements["B4"], byPassStatements["B2"], byPassStatements["B5"]]
    case "restrict_international_cards":
      return [byPassStatements["B2"], byPassStatements["B5"]]
    case "restrict_international_returns":
      return [byPassStatements["B6"], byPassStatements["B7"]]
    case "restrict_international_warranties_coverage":
      return [byPassStatements["B1"], byPassStatements["B2"], byPassStatements["B9"]]
  }
}

export function getRestrictionHeadings(restrictions, brandLink) {
  const headings = [];
  console.log(Object.keys(restrictions), "Object.keys(restrictions)")
  Object.keys(restrictions)?.map(key => {
    if (restrictions[key] == "Yes") {
      headings.push(getStatement(key, brandLink))
    }
  })

  return headings;
}

export function getByPassStatements(restrictions, brandLink) {
  const byPassStatements = [];
  Object.keys(restrictions)?.map(key => {
    if (restrictions[key] == "Yes") {
      console.log(getByPassStatementsByHeading(key), key, "getByPassStatementsByHeading[key]")
      byPassStatements.push(...getByPassStatementsByHeading(key))
    }
  })

  return byPassStatements;
}